// Stored layers are bottom-to-top. French remains a surface property for
// backward compatibility, with an optional insertion point among those layers.
export const FRENCH_LAYER_ID='__french__';
export const hasFrench=nail=>Boolean(nail?.french?.enabled||nail?.finish==='french');
const frenchIndex=nail=>Math.max(0,Math.min(nail?.layers?.length||0,Number.isFinite(nail?.french?.layerIndex)?Math.round(nail.french.layerIndex):0));

export function orderedNailLayers(nail){
 const layers=[...(nail?.layers||[])];
 if(hasFrench(nail))layers.splice(frenchIndex(nail),0,{...nail.french,id:FRENCH_LAYER_ID,kind:'french',visible:true,clip:true,opacity:nail.french?.opacity??1});
 return layers;
}

export function reorderNailLayer(nail,id,direction){
 if(!['up','down'].includes(direction))return nail;
 const stack=orderedNailLayers(nail),from=stack.findIndex(layer=>layer.id===id),to=from+(direction==='up'?1:-1);
 if(from<0||to<0||to>=stack.length)return nail;
 [stack[from],stack[to]]=[stack[to],stack[from]];
 const index=stack.findIndex(layer=>layer.id===FRENCH_LAYER_ID);
 return{...nail,layers:stack.filter(layer=>layer.id!==FRENCH_LAYER_ID),...(index>=0?{french:{...nail.french,layerIndex:index}}:{})};
}

// Deleting artwork underneath French must not move French over another layer.
// Newly added artwork keeps the established behavior of appearing on top.
export function withNailLayers(nail,layers){
 const below=new Set((nail.layers||[]).slice(0,frenchIndex(nail)).map(layer=>layer.id));
 const nextIndex=layers.filter(layer=>below.has(layer.id)).length;
 return{...nail,layers,...(Object.hasOwn(nail.french||{},'layerIndex')?{french:{...nail.french,layerIndex:nextIndex}}:{})};
}

export function removeNailLayer(nail,id){
 if(id===FRENCH_LAYER_ID)return{...nail,finish:nail.finish==='french'?'glossy':nail.finish,french:{...nail.french,enabled:false}};
 if(!nail.layers?.some(layer=>layer.id===id))return nail;
 return withNailLayers(nail,nail.layers.filter(layer=>layer.id!==id));
}
